export default "__VITE_ASSET__KHKQHAlE__"